var typeArray = function (arr) { return arr; };
var tabFilterKeys = typeArray([
    'all',
    'createdByMe',
    'recent',
    'shared',
    'favorites',
    'drafts',
    'meetings',
    'meetingRecordings',
    'people',
    'playlists',
    'cloudFiles',
    'local',
    'attachments',
]);
export var isTabFilterKey = function (str) {
    return tabFilterKeys.includes(str);
};
//# sourceMappingURL=TabFilterKey.js.map